export const createStyles = (theme?: any) => {
  return {
    main: {
      fontSize: '0.75rem',
      fontWeight: 400,
      lineHeight: '20px',
      letterSpacing: '0.15px',
      color: theme?.palette?.text?.secondary,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    subtitle: {
      fontWeight: 500,
      color: theme?.palette?.text?.primary,
    },
    metaDataContainer: {
      mt: '0.5rem',
    },
  };
};
